import React, { useContext } from "react";
import LinkButton from "../UI/LinkButton/LinkButton";
import classes from "./Sidebar.module.css";
import { useLocation, useParams } from "react-router-dom";
import CenterSidebar from "../CenterSidebar/CenterSidebar";
import { MainContext, MainContextState } from "../../context/MainContext";

const Sidebar = () => {
    const isAdmin = localStorage.getItem("admin_role") === "true";
    const { id } = useParams();
    const router = useLocation();
    const { user } = useContext<Partial<MainContextState>>(MainContext);
    return (
        <div className={classes.sidebar}>
            {router.pathname.includes(`centers/${id}`) ? (
                <CenterSidebar path={`centers/${id}`} />
            ) : (
                <>
                    <span>
                        Добро пожаловать <br />
                        <b>
                            {user?.surname} {user?.name} {user?.lastname}
                        </b>
                    </span>
                    <div className={classes.sidebar__buttons}>
                        {!isAdmin && <LinkButton to={"data"}>Личный кабинет</LinkButton>}
                        <LinkButton to={"centers"}>Все ЦП</LinkButton>
                        {isAdmin && <LinkButton to={"reportControlPoints"}>Контрольные точки</LinkButton>}
                    </div>
                </>
            )}
        </div>
    );
};

export default Sidebar;
